import { EXPLORE_STEPS, getStepIndex } from './routes';

export function getExploreProgress(currentStep, completedSteps = []) {
  const currentIndex = Math.max(getStepIndex(currentStep), 0);
  const completedCount = new Set([...completedSteps, ...EXPLORE_STEPS.slice(0, currentIndex).map((step) => step.id)]).size;
  return Math.min(100, Math.round((completedCount / EXPLORE_STEPS.length) * 100));
}
